import React, { FocusEvent, useMemo } from "react";
import { Form } from "react-bootstrap";

import classNames from "classnames";
import { useAppSelector } from "../../redux/Store";
import { ITRFilingSelector } from "../../redux/slice/ITRFilingSlice";
import FieldError from "./FieldError";

type Props = {
  name: string;
  value: string | number | undefined;
  onChange: (value: string) => void;
  onBlur: (e: FocusEvent<HTMLInputElement>) => void;
  isInvalid?: boolean;
  label?: JSX.Element | string;
  isRequired?: boolean;
  errorMsg?: string;
  placeholder?: string;
  classes?: any;
  isDisabled?: boolean;
  maxLength?: number;
  note?: string;
  formType?: "ITR" | "GENERAL";
};

const TextInputField: React.FC<Props> = (props: Props) => {
  const {
    name,
    value,
    onBlur,
    onChange,
    isInvalid,
    errorMsg,
    placeholder = "",
    isDisabled = false,
    maxLength = 255,
    note,
    label = "",
    isRequired = false,
    formType = "ITR"
  } = props;

  const { isFilingReadOnly } = useAppSelector(ITRFilingSelector);

  const isFieldDisabled = useMemo(() => {
    if (formType === "GENERAL") {
      if (isDisabled) {
        return isDisabled;
      }
      return false;
    }
    if (isFilingReadOnly) {
      return true;
    }
    return isDisabled;
  }, [isDisabled, isFilingReadOnly, formType]);

  return (
    <>
      <Form.Group className="form-group" controlId={name}>
        {label ? (
          <Form.Label className={classNames("small-label", isRequired && "required-field")}>
            {label}
          </Form.Label>
        ) : null}
        <Form.Control
          type="text"
          autoComplete="false"
          placeholder={placeholder}
          maxLength={maxLength}
          name={name}
          value={value}
          onBlur={onBlur}
          onChange={(e) => onChange(e.target.value)}
          isInvalid={isInvalid}
          disabled={isFieldDisabled}
        />
        {note && !isInvalid && !errorMsg && <Form.Text className="field-text">{note}</Form.Text>}
        {isInvalid && errorMsg && <FieldError message={errorMsg} />}
      </Form.Group>
    </>
  );
};

export default TextInputField;
